import { PageObject, PAGEOBJECTTYPE } from "./pageobject";
import { ObjectProperty, OBJECTPROPERTYTYPE } from "./objectproperty";

export class PageObjectButton extends PageObject {
  text: string;
  font: string;
  fontSize: number;
  icon: string;
  buttonType: string;
  enable: boolean;
  action: string;

  constructor(obj: PageObjectButton = null, style: string = "") {
    super(obj);
    this._type = PAGEOBJECTTYPE.Button;

    if (obj == null) {
      this.text = "Button";
      this.font = "arial";
      this.fontSize = 16;
      this.icon = "";
      this.buttonType = "btn-default";
      this.enable = true;
      this.action = "";
    } else {
      this.text = obj.text;
      this.font = obj.font;
      this.fontSize = obj.fontSize;
      this.icon = obj.icon;
      this.buttonType = obj.buttonType;
      this.enable = obj.enable;
      this.action = obj.action;
    }
  }

  getPropertiesList(): ObjectProperty[] {
    let list = super.getPropertiesList();

    list.push(new ObjectProperty("Text", OBJECTPROPERTYTYPE.Text));
    list.push(new ObjectProperty("Font", OBJECTPROPERTYTYPE.Text));
    list.push(new ObjectProperty("Font Size", OBJECTPROPERTYTYPE.Text));
    list.push(new ObjectProperty("Icon", OBJECTPROPERTYTYPE.Text));
    let buttonType = new ObjectProperty("Button Type", OBJECTPROPERTYTYPE.List);
    buttonType.addOption("btn-default", "Default");
    buttonType.addOption("btn-primary", "Primary");
    buttonType.addOption("btn-success", "Success");
    buttonType.addOption("btn-info", "Info");
    buttonType.addOption("btn-warning", "Warning");
    buttonType.addOption("btn-danger", "Danger");
    buttonType.addOption("btn-link", "Link");
    list.push(buttonType);
    list.push(new ObjectProperty("Enable", OBJECTPROPERTYTYPE.Boolean));
    list.push(new ObjectProperty("Action", OBJECTPROPERTYTYPE.TextLong));

    return list;
  }

  getPropertyValue(name: string): any {
    if (name == "Text") {
      return this.text;
    } else if (name == "Font") {
      return this.font;
    } else if (name == "Font Size") {
      return this.fontSize;
    } else if (name == "Icon") {
      return this.icon;
    } else if (name == "Button Type") {
      return this.buttonType;
    } else if (name == "Enable") {
      return this.enable;
    } else if (name == "Action") {
      return this.action;
    }

    return super.getPropertyValue(name);
  }

  setPropertyValue(name: string, value: any, style: string): void {
    super.setPropertyValue(name, value, style);

    if (name == "Text") {
      this.text = value;
    } else if (name == "Font") {
      this.font = value;
    } else if (name == "Font Size") {
      let newValue = Number(value);
      if (!isNaN(newValue)) {
        this.fontSize = newValue;
      }
    } else if (name == "Icon") {
      this.icon = value;
    } else if (name == "Button Type") {
      this.buttonType = value;
    } else if (name == "Enable") {
      this.enable = value == "true";
    } else if (name == "Action") {
      this.action = value;
    }
  }
}
